import { useTranslation } from 'react-i18next';
import { FC, useMemo } from 'react';

import './style.scss';

export enum ENotFoundType {
  NOT_FOUND,
  PRIVACY_ACCOUNT,
}

interface INotFoundProps {
  /**
   * @default ENotFoundType.NOT_FOUND
   */
  type?: ENotFoundType;
}

export const NotFound: FC<INotFoundProps> = (props) => {
  const { t } = useTranslation();
  const { type = ENotFoundType.NOT_FOUND } = props;

  const hint = useMemo(() => {
    switch (type) {
      case ENotFoundType.PRIVACY_ACCOUNT:
        return t('privateAccount_web_description');
      case ENotFoundType.NOT_FOUND:
      default:
        return t('article_not_found');
    }
  }, [type]);

  return (
    <div className="not_found">
      <div className="not_found_cover" />
      <div className="not_found_text">{hint}</div>
    </div>
  );
};
